'use client';

import { useSite } from '@/contexts/SiteContext';
import { craftSdk } from '@/helpers/craft-sdk';
import { createCraftVarsForClient } from '@/lib/preview-utils-client';
import type { Event_Entry } from '@/types/graphql';
import { useEffect, useState } from 'react';
import FloatingCalendarButton from './FloatingCalendarButton';

export default function FloatingCalendar() {
    const { locale } = useSite();
    const [events, setEvents] = useState<Event_Entry[]>([]);

    useEffect(() => {
        const fetchEvents = async () => {
            const { data } = await craftSdk.FloatingCalendar(createCraftVarsForClient(locale));
            const shows = data.shows?.filter((show: Event_Entry) => show !== null) as Event_Entry[];
            setEvents(shows);
        };

        fetchEvents();
    }, [locale]);

    return <FloatingCalendarButton events={events} />;
}
